// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3pHwp","disabled":"FileBtn_disabled__FC8n9","warn":"FileBtn_warn__23T8b","fade":"FileBtn_fade__1Bjli"};